import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import SelectStore from './SelectStore';

const PAGE_SIZE_OPTIONS = [{ value: 10 }, { value: 25 }, { value: 50 }, { value: 100 }];
const DEFAULT_PAGE_SIZE = 10;

export default class PaginationStore {
    static PropType = PropTypes.shape({
        itemTotalCount: PropTypes.number.isRequired,
        pageIndex: PropTypes.number.isRequired,
        pageSizeSelect: SelectStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class PaginationStore */ {
            itemTotalCount: 0,
            pageIndex: 0,
            pageSizeSelect: new SelectStore({ options: PAGE_SIZE_OPTIONS, value: DEFAULT_PAGE_SIZE }),
        }, data);
    }

    setItemTotalCount = action((count) => {
        this.itemTotalCount = count;
    });

    onPage = action((pageIndex) => {
        this.pageIndex = Math.max(0, pageIndex);
    });

    takePageFromList(arr) {
        return arr.slice(this.pageIndex * this.pageSizeSelect.value, (this.pageIndex + 1) * this.pageSizeSelect.value);
    }
}
